// import { Avocado } from './loaders/Avocado';
import { Watermelon } from './loaders/Watermelon';

export const Loader = () => {
    // const loaders = [Avocado, Watermelon];
    // const randomLoader = loaders[Math.floor(Math.random() * loaders.length)];
    // return randomLoader();
    return <Watermelon />;
}
